const Badge = ({ color = 'primary', theme = 'light', className, children }) => {
    return (
        <span className={`badge badge-${theme}-${color} fw-bolder me-auto px-4 py-3 ${className}`}>
            { children }
        </span>
    )
}

export default Badge
